import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import TakhmeenList from "./TakhmeenList";
import AddTakhmeen from "./AddTakhmeen";
import EditTakhmeen from "./EditTakhmeen";
import ViewTakhmeen from "./ViewTakhmeen";
import PageNotFound from "../pageNoFound";
import AllowedAccess from "../../Layout/AllowedAccess";
import ErrorBoundry from "../../Services/ErrorBoundry";

export const canManageTakhmeen = (userData) => (
    userData.role_slug === "super_admin"
    || userData.caps_list.includes("manage_takhmeen")
    || userData.caps_list.includes("add_takhmeen")
    || userData.caps_list.includes("edit_takhmeen")
    || userData.caps_list.includes("assign_takhmeen_members")
);

export const canAccessTakhmeen = (userData) => !!userData?.id;

export const hasTakhmeenCapability = (userData) => (
    userData?.caps_list?.includes("view_takhmeen")
    || userData?.caps_list?.includes("manage_takhmeen")
    || userData?.caps_list?.includes("add_takhmeen")
    || userData?.caps_list?.includes("edit_takhmeen")
    || userData?.caps_list?.includes("assign_takhmeen_members")
);

export const canViewAllOrgTakhmeens = (userData) => (
    userData?.role_slug === "super_admin"
    || canManageTakhmeen(userData)
    || (userData?.role_slug === "org_admin" && hasTakhmeenCapability(userData))
);

export { formatTakhmeenAmount } from "./takhmeenFormat";

const TakhmeenRoutes = () => {
    const { userData } = useSelector((state) => state.user);
    if (!canAccessTakhmeen(userData)) return <ErrorBoundry />;

    return (
        <Routes>
            <Route index element={<TakhmeenList />} />
            <Route path="view" element={<ViewTakhmeen />} />
            <Route path="add" element={
                <AllowedAccess role={userData.role_slug} allowedRoles={["super_admin"]}
                    allowedPermissions={["add_takhmeen", "manage_takhmeen"]} userPermissions={userData.caps_list}
                    renderNoAccess={() => <ErrorBoundry />} children={<AddTakhmeen />} />
            } />
            <Route path="edit" element={
                <AllowedAccess role={userData.role_slug} allowedRoles={["super_admin"]}
                    allowedPermissions={["edit_takhmeen", "manage_takhmeen"]} userPermissions={userData.caps_list}
                    renderNoAccess={() => <ErrorBoundry />} children={<EditTakhmeen />} />
            } />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default TakhmeenRoutes;
